import { createContext } from 'react';

export const defaultUserConfigContext = {
  API_HOST: process.env.REACT_APP_API_HOST ?? '',
};

const UserConfigContext = createContext(defaultUserConfigContext);
export default UserConfigContext;
